import React, { useEffect, useState } from 'react';
import { isBrowser, isMobile } from './browser';
export function useLayout() {
  const [mobile, setMobile] = useState(false);
  const [width, setWidth] = useState(0);

  const handleResize = (event) => {
    setMobile(isMobile());
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    if (!isBrowser()) return () => {};

    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);

    setTimeout(() => {
      handleResize();
    }, 200);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('load', handleResize);
    };
  }, []);

  return {
    mobile,
    width,
  };
}
